<template>
  <div>
    
    <span v-if="numErrorOnCent(cent,lampsType) >0 && ((orphanFilter==false && emergencyFilter==false) || (orphanFilter==true && errorFilter==true) || (emergencyFilter==true && errorFilter==true ))" class="d-flex justify-content-center" style="color: red;">
      <strong>
        {{ numErrorOnCent(cent,lampsType) + " " + this.$t("details_cu_modal.cu_error").toLowerCase()}}
      </strong>
    </span>
    <span v-if="numErrorSpecOnCent(cent,lampsType,'error_com') >0 && errorComFilter==true" class="d-flex justify-content-center" style="color: orange;">
      <strong>
        {{ numErrorSpecOnCent(cent,lampsType,"error_com") + " " + this.$t("filter.error_com").toLowerCase()}}
      </strong>
    </span>
    <span v-if="numErrorSpecOnCent(cent,lampsType,'error_hardware') >0 && errorHardwareFilter==true" class="d-flex justify-content-center" style="color: red;">
      <strong>
        {{ numErrorSpecOnCent(cent,lampsType,"error_hardware") + " " + this.$t("filter.error_hardware").toLowerCase()}}
      </strong>
    </span>
    <span v-if="numErrorSpecOnCent(cent,lampsType,'error_led') >0 && this.errorLedFilter==true" class="d-flex justify-content-center" style="color: red;">
      <strong>
        {{ numErrorSpecOnCent(cent,lampsType,"error_led") + " " + this.$t("filter.error_led").toLowerCase()}}
      </strong>
    </span>
        <span v-if="numErrorSpecOnCent(cent,lampsType,'battery') >0 && errorBatteryFilter==true" class="d-flex justify-content-center" style="color: red;">
      <strong>
        {{ numErrorSpecOnCent(cent,lampsType,"battery") + " " + this.$t("filter.error_battery").toLowerCase()}}
      </strong>
    </span>
        <span v-if="numErrorSpecOnCent(cent,lampsType,'other')  >0 && errorOtherFilter==true" class="d-flex justify-content-center" style="color: red;">
      <strong>
        {{ numErrorSpecOnCent(cent,lampsType,"other") + " " + this.$t("filter.error_other").toLowerCase()}}
      </strong>
    </span>
    <span v-if="cent.cu_type=='logicafm' && numOrphanOnCent(cent,lampsType)>0 && (orphanFilter==true || (errorFilter==false && emergencyFilter==false && errorComFilter==false))" class="d-flex justify-content-center" style="color: violet;">  
      <strong>
        {{ numOrphanOnCent(cent,lampsType) + " " + this.$t("details_cu_modal.cu_orphan").toLowerCase()}}
      </strong>
    </span>
    <span v-if="numEmergencyOnCent(cent,lampsType)>0 && (emergencyFilter==true || (errorFilter==false && errorComFilter==false &&  orphanFilter==false))" class="d-flex justify-content-center" style="color: orange;">  
      <strong>
        {{ numEmergencyOnCent(cent,lampsType) + " " + this.$t("report_pdf.num_lampade_emergency").toLowerCase()}}
      </strong>
    </span>
    
 </div>
</template>

<script>

export default {
  name: "errorLampsOnCent",
  props: {
    cent: {
      default: null
    },
    orphanFilter: null,
    emergencyFilter: null,
    errorFilter: null,
    errorComFilter: null,
    errorLedFilter: null,
    errorHardwareFilter: null,
    errorBatteryFilter: null,
    errorOtherFilter: null,
    lampsType: null
  },
  data() {
    return {
    };
  },
 
  methods: {
          numErrorSpecOnCent(cent,lampType,errorType)
          {
            var total = 0;
     
            if (lampType == "emergency")
            {
                cent.lamps.forEach((l) =>
                {
                  if (errorType != "battery" && errorType != "other")
                  {
                    if(l[errorType] == "ON")
                    total = total + 1;
                  }
                  else if (errorType == "battery")
                  {
                    if(l["error_battery_short"]=='ON' || l["error_battery_test"]=='ON' || l["error_battery_test_auto"]=='ON')
                    total = total + 1;
                  }
                });
                return total;
            }

            else if (lampType == "lighting")
            {
                cent.lamps_illum.forEach((l) =>
                {
                    if (errorType!="battery" && errorType!="other" && l[errorType] == "ON")
                        total = total + 1;
                });
                return total;
            }
            
            else if(lampType=="all")
            {
               cent.lamps.forEach((l) =>
                {
                    if (errorType!="battery" && errorType!="other" && l[errorType] == "ON")
                        total = total + 1;
               });
                
                cent.lamps_illum.forEach((l) =>
                {
                    if (errorType!="battery" && errorType!="other" && l[errorType] == "ON")
                        total = total + 1;
                });
              
              return total;
            }
       
          },
          
          numErrorOnCent(cent,lampType)
          {
            var total = 0;

            if (lampType == "emergency")
            {
                cent.lamps.forEach((l) =>
                {
                    if (l.error_batt_short == "ON" || l.error_batt_test == "ON"
                        || l.error_batt_test_auto == "ON" || l.error_tubo_UV == "ON"
                        || l.error_com == "ON" || l.error_led == "ON" || l.error_comm_radio_lamp == "ON"
                        || l.error_hardware == "ON"
                        || l.error_overpower == "ON"
                        || l.error_underpower == "ON"
                        || l.error_overvoltage == "ON"
                        || l.error_undervoltage == "ON")
                        total = total + 1;
                });
                return total;
            }

            else if (lampType == "lighting")
            {
                cent.lamps_illum.forEach((l) =>
                {
                    if ( l.error_tubo_UV == "ON"
                        || l.error_com == "ON"
                        || l.error_comm_radio_lamp == "ON"
                        || l.error_led == "ON"
                        || l.error_hardware == "ON"
                        || l.error_overpower == "ON"
                        || l.error_underpower == "ON"
                        || l.error_overvoltage == "ON"
                        || l.error_undervoltage == "ON")
                        
                        total = total + 1;
                });
                return total;
            }
            
            else if(lampType=="all")
            {
              return (cent.num_lamp_error);
            }
       
          },
          
          numOrphanOnCent(cent,lampType)
          {
            var total = 0;

            if (lampType == "emergency")
            {
                cent.lamps.forEach((l) =>
                {
                    if (l.nodo_orfano == true)
                        total = total + 1;
                });
                return total;
            }

            else if (lampType == "lighting")
            {
                cent.lamps_illum.forEach((l) =>
                {
                  if (l.nodo_orfano == true)
                        total = total + 1;
                });
                return total;
            }
            else if(lampType=="all")
            {
              return (cent.num_nodi_orfani);
            }
          },

          numEmergencyOnCent(cent)
          {
            var total=0;
            cent.lamps.forEach((l) =>
                {
                    if (l.emer_active=="EMERGENZA IN CORSO")
                        total = total + 1;
                });
                return total;
          }
      }
   
  }
  
</script>
